import styled from 'styled-components';

const Message = styled.div`
  margin-top: 16px;
  margin-left: 16px;
  font-size: 28px;
  font-weight: bold;
`;

export default Message;
